import script from "./addregion.vue?vue&type=script&setup=true&lang=js"
export * from "./addregion.vue?vue&type=script&setup=true&lang=js"

import "./addregion.vue?vue&type=style&index=0&id=5687d48d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5687d48d"]])

export default __exports__